// ==================================================================================================
//
// Breakpoint Utitlity
//
// ==================================================================================================
import { universal } from '../controllers/controllers';
import { throttle }  from './savnac';

const breakpoint = () => {
  let props = {
    universalMods: window.CrunchMemberPortal.getUniversalModules(),
    pageMods: null,
    allModules: null,
    isEnabled: false,
    currentBreakpoint: window.CrunchMemberPortal.checkBreakpoint()
  };

  const createChildren = () => {
    props.pageMods = window.CrunchMemberPortal.getPageModules();
    props.allModules = Object.assign({}, props.pageMods, props.universalMods);

    return;
  }

  const runResponsive = () => {
    Object.keys(props.allModules).forEach(module => {
      let mod = props.allModules[module];
      if (mod.responsiveCallbacks && mod.responsiveCallbacks[props.currentBreakpoint]) {
        mod.responsiveCallbacks[window.CrunchMemberPortal.currentBreakpoint]();
      }
    });

    return;
  }

  // ------------------------------------------------
  // On resize, set new breakpoint
  // ------------------------------------------------
  const onResize = (e) => {
    window.CrunchMemberPortal.currentBreakpoint = window.CrunchMemberPortal.checkBreakpoint();

    if (window.CrunchMemberPortal.currentBreakpoint !== props.currentBreakpoint) {
      props.currentBreakpoint = window.CrunchMemberPortal.currentBreakpoint;
      runResponsive();
    }

    return;
  }

  const enable = () => {
    if (props.isEnabled) return;
    props.resizeHandler = throttle(onResize, 100);

    window.addEventListener('resize', props.resizeHandler);
    return;
  }

  const disable = () => {
    if (!props.isEnabled) return;

    window.removeEventListener('resize', props.resizeHandler);
    return;
  }

  const init = () => {
    createChildren();
    runResponsive();
    enable();
    return;
  }

  return {
    init,
    enable,
    disable
  };
}

export default breakpoint;
